/**
 * 一个模型版本里的「小模型」列表（版本查询、模型查询共用）：模型名称 + tag（文件后缀，即格式）。
 * 归组规则见 utils/modelCatalog.groupSubModels：engine 去掉 `_GPU_Trt<版本>_<精度>` 尾巴后与同名 onnx 合并。
 */
import { Table, Tag, Tooltip, Typography } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { groupSubModels, type SubModel } from '@/utils/modelCatalog';

const { Text } = Typography;

const TAG_COLOR: Record<string, string> = { onnx: 'gold', engine: 'magenta', plan: 'magenta', json: 'blue' };

const columns: ColumnsType<SubModel> = [
  {
    title: '模型名称', dataIndex: 'name', width: 360,
    render: (v: string) => <Text style={{ fontFamily: 'ui-monospace, monospace' }}>{v}</Text>,
  },
  {
    title: 'tag',
    render: (_, r) => (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
        {r.tags.map((t) => (
          <Tooltip key={t.file} title={t.file}>
            <Tag color={TAG_COLOR[t.tag]} style={{ marginInlineEnd: 0 }}>{t.tag}</Tag>
          </Tooltip>
        ))}
      </div>
    ),
  },
];

export default function SubModelTable({ files, dimmed }: { files: string[]; dimmed?: boolean }) {
  const data = groupSubModels(files);
  return (
    <Table<SubModel>
      rowKey="name" size="small" dataSource={data} columns={columns} pagination={false}
      style={{ margin: '2px 0', opacity: dimmed ? 0.6 : 1 }}
      locale={{ emptyText: '没有文件' }}
    />
  );
}

/** 列表里的「小模型」数量单元格。 */
export function SubModelCount({ files }: { files: string[] }) {
  const n = groupSubModels(files).length;
  return <Text type={n ? undefined : 'secondary'}>{n} 个</Text>;
}
